import { render, staticRenderFns } from "./VersionForm.vue?vue&type=template&id=4bc6ccaa&scoped=true"
import script from "./VersionForm.vue?vue&type=script&lang=js"
export * from "./VersionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6ccaa",
  null
  
)

export default component.exports